/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAllocatedPremiumScheduleQueryDto
 */
export interface GetAllocatedPremiumScheduleQueryDto {
    /**
     * Receipt ID to filter by
     * @type {number}
     * @memberof GetAllocatedPremiumScheduleQueryDto
     */
    receiptId: number;
}

/**
 * Check if a given object implements the GetAllocatedPremiumScheduleQueryDto interface.
 */
export function instanceOfGetAllocatedPremiumScheduleQueryDto(value: object): value is GetAllocatedPremiumScheduleQueryDto {
    if (!('receiptId' in value) || value['receiptId'] === undefined) return false;
    return true;
}

export function GetAllocatedPremiumScheduleQueryDtoFromJSON(json: any): GetAllocatedPremiumScheduleQueryDto {
    return GetAllocatedPremiumScheduleQueryDtoFromJSONTyped(json, false);
}

export function GetAllocatedPremiumScheduleQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllocatedPremiumScheduleQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'receiptId': json['receiptId'],
    };
}

export function GetAllocatedPremiumScheduleQueryDtoToJSON(json: any): GetAllocatedPremiumScheduleQueryDto {
    return GetAllocatedPremiumScheduleQueryDtoToJSONTyped(json, false);
}

export function GetAllocatedPremiumScheduleQueryDtoToJSONTyped(value?: GetAllocatedPremiumScheduleQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiptId': value['receiptId'],
    };
}

